export default __webpack_public_path__ + "/static/media/jobhunter-common-web/avatar.a31fb58ae9a17f58bf24d5c8339ea024.png";